import React from "react";
import { getAllParams } from '../../service/utils';

const AccessibilityTh = ({ children, ...params }) => {
    return (
        <th scope='col' {...getAllParams(params)}>
            {children}
        </th>
    );
};
export default AccessibilityTh;
